import $ from 'jquery';

// Registration open date value getting from sitecore
var ceOpenDate =$("#registrationOpenDate").val();
// Registration close date value getting from sitecore
var ceEndDate =$("#registrationCloseDate").val();
// RSVP close date value getting from sitecore
var rsvpEndDate =$("#resvpCloseDate").val();

// Set the date we're counting down to
var countDownOpenDate = new Date(ceOpenDate).getTime();
var countDownCloseDate = new Date(ceEndDate).getTime();
var countDownRsvpDate = new Date(rsvpEndDate).getTime();
// Registration Open Timer Function

var ceX = setInterval(function() {

  // Get today's date and time
  var nowOpenReg = new Date().getTime();
    
  // Find the distance between now and the count down date
  var ceOpenTimer = countDownOpenDate - nowOpenReg;
    
  // Time calculations for days, hours, minutes and seconds
  var cedays = Math.floor(ceOpenTimer / (1000 * 60 * 60 * 24));
  var cehours = Math.floor((ceOpenTimer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var ceminutes = Math.floor((ceOpenTimer % (1000 * 60 * 60)) / (1000 * 60));
  var ceseconds = Math.floor((ceOpenTimer % (1000 * 60)) / 1000);
  if ($( "#cwm-open-timer" ).length > 0) {
    document.getElementById("cwm-open-timer").innerHTML = cedays + "days " + cehours + "hours "
    + ceminutes + "minutes " + ceseconds + "seconds ";
 } else {
  clearInterval(ceX);
 }
    
  // If the count down is over, write some text 
  if (ceOpenTimer < 0) {
    clearInterval(ceX);
    document.getElementById("cwm-open-timer").innerHTML = "00:00:00:00";
  }
}, 1000);

// Registration Close Date

var ceY = setInterval(function() {

  // Get today's date and time
  var nowCloseReg = new Date().getTime();
    
  // Find the distance between now and the count down date
  var ceCloseTimer = countDownCloseDate - nowCloseReg;
    
  // Time calculations for days, hours, minutes and seconds
  var ceClosedays = Math.floor(ceCloseTimer / (1000 * 60 * 60 * 24));
  var ceClosehours = Math.floor((ceCloseTimer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var ceCloseminutes = Math.floor((ceCloseTimer % (1000 * 60 * 60)) / (1000 * 60));
  var ceCloseseconds = Math.floor((ceCloseTimer % (1000 * 60)) / 1000);
    
  if ($( "#cwm-close-timer" ).length > 0) {
    document.getElementById("cwm-close-timer").innerHTML = ceClosedays + "days " + ceClosehours + "hours "
    + ceCloseminutes + "minutes " + ceCloseseconds + "seconds ";
 } else {
  clearInterval(ceY);
 }

    
  // If the count down is over, write some text 
  if (ceCloseTimer < 0) {
    clearInterval(ceY);
    document.getElementById("cwm-close-timer").innerHTML = "00:00:00:00";
  }
}, 1000);

// Registration Close Date

var ceRSVP = setInterval(function() {

  // Get today's date and time
  var nowRsvpClose = new Date().getTime();
    
  // Find the distance between now and the count down date
  var rsvpCloseTimer = countDownRsvpDate - nowRsvpClose;
    
  // Time calculations for days, hours, minutes and seconds
  var rsvpClosedays = Math.floor(rsvpCloseTimer / (1000 * 60 * 60 * 24));
  var rsvpClosehours = Math.floor((rsvpCloseTimer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var rsvpCloseminutes = Math.floor((rsvpCloseTimer % (1000 * 60 * 60)) / (1000 * 60));
  var rsvpCloseseconds = Math.floor((rsvpCloseTimer % (1000 * 60)) / 1000);
    
  if ($( "#cwm-rsvp-close" ).length > 0) {
    document.getElementById("cwm-rsvp-close").innerHTML = rsvpClosedays + "days " + rsvpClosehours + "hours "
    + rsvpCloseminutes + "minutes " + rsvpCloseseconds + "seconds ";
 } else {
  clearInterval(ceRSVP);
 }

    
  // If the count down is over, write some text 
  if (rsvpCloseTimer < 0) {
    clearInterval(ceRSVP);
    document.getElementById("cwm-rsvp-close").innerHTML = "00:00:00:00";
  }
}, 1000);



// WEBPACK FOOTER //
// ./components/cwm-connection-event/cwm-countdown-timer.js